import { Checkbox } from '@kursk/components/ui/Checkbox/Checkbox';
import { useCallback, useState } from 'react';
import _ from 'lodash';
import styles from './CheckboxSelectMobileFilterSimple.module.scss';
import { BackArrowIcon, CloseIconSmall } from '@kursk/components/ui/icons';
import { useDeepEffect } from "@common/hooks/useDeepEffect";

interface IProps {
  items: any[];
  selectedItems?: string[];
  // eslint-disable-next-line @typescript-eslint/ban-types
  onChange: (values: any[]) => void;
  getBack: () => void;
  close: () => void;
  title: string;
}

export function CheckboxSelectMobileFilterSimple({
  items,
  selectedItems,
  onChange,
  getBack,
  close,
  title,
}: IProps) {
  const [selected, setSelected] = useState(selectedItems);

  useDeepEffect(() => {
    setSelected(selectedItems);
  }, [selectedItems])

  const onSubmit = async () => {
    await onChange(selected);
  }

  const onReset = async () => {
    setSelected([]);
    await onChange([]);
  }

  const onSelect = useCallback((item: any) => {
    let newSelected;
    if (selected.includes(item.value)) {
      newSelected = _.without(selected, item.value);
    } else {
      newSelected = [...selected, item.value];
    }

    setSelected(newSelected);
  }, [selected]);

  return (
    <div className={styles.content}>
      <div className={styles.header}>
        <button className={styles.backButton} onClick={getBack}>
          <BackArrowIcon width={18} height={13}/>
        </button>
        <div className={styles.headerTitle}>
          {title}
        </div>
        <button className={styles.closeButton} onClick={close}>
          <CloseIconSmall width={14} height={14}/>
        </button>
      </div>
      <div className={styles.list}>
        <div className={styles.optionsList}>
          {items.map((item) => (
            <div className={styles.listItem} key={item.value}>
              <Checkbox
                value={item.value}
                onChange={() => onSelect(item)}
                checked={selected.includes(item.value)}
              >
                {item.name}
              </Checkbox>
            </div>
          ))}
        </div>
      </div>
      <div className={styles.buttonContainer}>
        <button
          className={styles.clearButton}
          onClick={() => {
            onReset();
            getBack();
          }}
        >
          очистить
        </button>
        <button
          className={styles.submitButton}
          onClick={() => {
            onSubmit();
            getBack();
          }}
        >
          применить
        </button>
      </div>
    </div>
  );
}
